<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005eff"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="red" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-start>
      <v-container class="px-0" fluid>
        <v-switch
          v-model="is24x7"
          :label="`is24x7: ${is24x7.toString()}`"
        ></v-switch>
      </v-container>
      <v-layout wrap>
        <v-flex md2 lg2 xs2 xl2 sm2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Sunday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3 sm3>
          <v-menu
            ref="menu1"
            v-model="sun.sun1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="sun.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!sun.working"
                v-model="sun.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                required
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="sun.sun1"
              v-model="sun.open"
              full-width
              @click:minute="$refs.menu1.save(sun.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu2"
            v-model="sun.sun2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="sun.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!sun.working"
                v-model="sun.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                required
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="sun.sun2"
              :rules="rule"
              v-model="sun.close"
              full-width
              @click:minute="$refs.menu2.save(sun.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="sun.working"
            :label="sun.working ? 'Workingday' : 'Holiday '"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md2 lg2 xs2 xl2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Monday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu3"
            v-model="mon.mon1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="mon.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!mon.working"
                v-model="mon.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="mon.mon1"
              v-model="mon.open"
              full-width
              @click:minute="$refs.menu3.save(mon.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu4"
            v-model="mon.mon2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="mon.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!mon.working"
                v-model="mon.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="mon.mon2"
              v-model="mon.close"
              full-width
              @click:minute="$refs.menu4.save(mon.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="mon.working"
            :label="mon.working ? 'Workingday' : 'Holiday'"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md2 lg2 xs2 xl2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Tuesday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu5"
            v-model="tue.tue1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="tue.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!tue.working"
                v-model="tue.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="tue.tue1"
              v-model="tue.open"
              full-width
              @click:minute="$refs.menu5.save(tue.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu6"
            v-model="tue.tue2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="tue.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!tue.working"
                v-model="tue.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="tue.tue2"
              v-model="tue.close"
              full-width
              @click:minute="$refs.menu6.save(tue.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="tue.working"
            :label="tue.working ? 'Workingday' : 'Holiday'"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md2 lg2 xs2 xl2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Wednesday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu7"
            v-model="wed.wed1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="wed.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!wed.working"
                v-model="wed.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="wed.wed1"
              v-model="wed.open"
              full-width
              @click:minute="$refs.menu7.save(wed.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu8"
            v-model="wed.wed2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="wed.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!wed.working"
                v-model="wed.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="wed.wed2"
              v-model="wed.close"
              full-width
              @click:minute="$refs.menu8.save(wed.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="wed.working"
            :label="wed.working ? 'Workingday' : 'Holiday'"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex m2 lg2 xs2 xl2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Thursday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu9"
            v-model="thu.thu1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="thu.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!thu.working"
                v-model="thu.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="thu.thu1"
              v-model="thu.open"
              full-width
              @click:minute="$refs.menu9.save(thu.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu10"
            v-model="thu.thu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="thu.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!thu.working"
                v-model="thu.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="thu.thu2"
              v-model="thu.close"
              full-width
              @click:minute="$refs.menu10.save(thu.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="thu.working"
            :label="thu.working ? 'Workingday' : 'Holiday'"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md2 lg2 xs2 xl2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Friday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu11"
            v-model="fri.fri1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="fri.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!fri.working"
                v-model="fri.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="fri.fri1"
              v-model="fri.open"
              full-width
              @click:minute="$refs.menu11.save(fri.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu12"
            v-model="fri.fri2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="fri.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!fri.working"
                v-model="fri.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="fri.fri2"
              v-model="fri.close"
              full-width
              @click:minute="$refs.menu12.save(fri.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="fri.working"
            :label="fri.working ? 'Workingday' : 'Holiday'"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md2 lg2 xs2 xl2 pt-5>
          <h3 style="font-weight: bold; color: black; font-size: 15px">
            Saturday
          </h3>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu13"
            v-model="sat.sat1"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="sat.open"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!sat.working"
                v-model="sat.open"
                label="Opening Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="sat.sat1"
              v-model="sat.open"
              full-width
              @click:minute="$refs.menu13.save(sat.open)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md3 lg3 xs3 xl3>
          <v-menu
            ref="menu14"
            v-model="sat.sat2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="sat.close"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :disabled="!sat.working"
                v-model="sat.close"
                label="Closing Time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="sat.sat2"
              v-model="sat.close"
              full-width
              @click:minute="$refs.menu14.save(sat.close)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 lg4 xs4 xl4 class="px-0" fluid>
          <v-switch
            :disabled="is24x7"
            v-model="sat.working"
            :label="sat.working ? 'Workingday' : 'Holiday'"
          ></v-switch>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-row class="justify-center" style="padding-top: 80px">
      <v-btn :disabled="!valid" outlined color="red" @click="validate()">
        Update Working Hours
      </v-btn>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  components: {},
  data() {
    return {
      ServerError: false,
      appLoading: false,
      showsnackbar: false,
      msg: null,
      valid: true,
      seller: [],
      is24x7: true,
      WorkingHours: true,
      sun: {
        working: false,
        day: "Sunday",
        open: "",
        close: "",
      },
      mon: {
        working: false,
        day: "Monday",
        open: "",
        close: "",
      },
      tue: {
        working: false,
        day: "Tuesday",
        open: "",
        close: "",
      },
      wed: {
        working: false,
        day: "Wednesday",
        open: "",
        close: "",
      },
      thu: {
        working: false,
        day: "Thursday",
        open: "",
        close: "",
      },
      fri: {
        working: false,
        day: "Friday",
        open: "",
        close: "",
      },
      sat: {
        working: false,
        day: "Saturday",
        open: "",
        close: "",
      },
      data: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      rule: [
        (v) =>
          /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(v) ||
          " Required",
      ],
    };
  },
  watch: {
    sun: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    mon: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    tue: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    wed: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    thu: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    fri: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    sat: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    validate() {
      //   if (this.$refs.profileForm.validate()) {
      this.edit();
      //   }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/" + this.storage,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.seller = response.data.data.sellerid;
          this.is24x7 = this.seller.is24x7;
          this.data = this.seller.workingHour[0];
          this.sun.open = this.data.open;
          this.sun.close = this.data.close;
          this.sun.working = this.data.working;
          this.data1 = this.seller.workingHour[1];
          this.mon.open = this.data1.open;
          this.mon.close = this.data1.close;
          this.mon.working = this.data1.working;
          this.data2 = this.seller.workingHour[2];
          this.tue.open = this.data2.open;
          this.tue.close = this.data2.close;
          this.tue.working = this.data2.working;
          this.data3 = this.seller.workingHour[3];
          this.wed.open = this.data3.open;
          this.wed.close = this.data3.close;
          this.wed.working = this.data3.working;
          this.data4 = this.seller.workingHour[4];
          this.thu.open = this.data4.open;
          this.thu.close = this.data4.close;
          this.thu.working = this.data4.working;
          this.data5 = this.seller.workingHour[5];
          this.fri.open = this.data5.open;
          this.fri.close = this.data5.close;
          this.fri.working = this.data5.working;
          this.data6 = this.seller.workingHour[6];
          this.sat.open = this.data6.open;
          this.sat.close = this.data6.close;
          this.sat.working = this.data6.working;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      var data = {};
      var workingHour = [];
      if (this.is24x7 == true) {
        data["is24x7"] = this.is24x7;
      } else {
        data["is24x7"] = this.is24x7;
        workingHour.push(this.sun);
        workingHour.push(this.mon);
        workingHour.push(this.tue);
        workingHour.push(this.wed);
        workingHour.push(this.thu);
        workingHour.push(this.fri);
        workingHour.push(this.sat);
        data["workingHour"] = workingHour;
      }
      data["uid"] = this.storage;
      axios({
        method: "POST",
        url: "/admin/seller/edit",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          this.msg = "Updated Successfully";
          this.showsnackbar = true;
          this.getData();
        } else {
          this.show = false;
          this.msg = "Updated Successfully";
          this.showsnackbar = true;
        }
      });
    },
  },
};
</script>